import { Guid } from '@web/utils';
import { PublicSales } from '@web/shared/module/shop';

export class PublicCosmeticBox {
  public constructor(
    private readonly data: {
      id: Guid;
      name: string;
      slug: string;
      sales: PublicSales;
    },
  ) {}

  public get id(): Guid {
    return this.data.id;
  }

  public get name(): string {
    return this.data.name;
  }

  public get slug(): string {
    return this.data.slug;
  }

  public get sales(): PublicSales {
    return this.data.sales;
  }
}
